"use client";

import { useState } from "react";

const CATEGORIES = [
  "Website",
  "Apps",
  "Resumes",
  "Video Editing",
  "Invitation",
  "General Questions",
  "Billing & Refunds",
  "Report a Bug",
  "Privacy & Data",
  "Other",
];

export default function WhatsAppContact({ phone }: { phone: string }) {
  const [category, setCategory] = useState(CATEGORIES[0]);
  const [customText, setCustomText] = useState("");

  const isOther = category === "Other";
  const message =
    isOther && customText.trim()
      ? `Hi Nohaya team, I'd like to ask about: ${customText.trim()}`
      : `Hi Nohaya team, I have a question about: ${category}`;
  const whatsappHref = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <div className="rounded-2xl border border-slate-200/80 bg-white/80 p-6 text-left backdrop-blur-sm dark:border-slate-800 dark:bg-[#0f172a]/80">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-600 dark:bg-emerald-500/20 dark:text-emerald-400">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.71.45 3.38 1.3 4.85L2.05 22l5.36-1.4a9.9 9.9 0 0 0 4.63 1.18h.01c5.46 0 9.9-4.45 9.9-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm5.8 14.1c-.24.68-1.4 1.3-1.93 1.35-.5.05-.99.24-3.32-.7-2.8-1.13-4.6-3.98-4.74-4.16-.14-.19-1.13-1.5-1.13-2.86 0-1.36.71-2.02.97-2.3.24-.26.53-.32.7-.32.18 0 .35 0 .5.01.16.01.38-.06.6.46.24.57.8 1.98.87 2.13.07.14.11.31.02.5-.09.19-.13.31-.27.47-.14.16-.29.36-.41.48-.14.14-.28.28-.12.56.16.28.71 1.17 1.52 1.9 1.05.94 1.93 1.23 2.21 1.37.28.14.44.12.6-.07.16-.19.68-.79.87-1.06.18-.28.36-.23.6-.14.24.09 1.55.73 1.82.86.27.14.45.2.51.32.06.12.06.68-.18 1.36z" />
          </svg>
        </div>
        <div>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">Chat on WhatsApp</h2>
          <p className="text-xs text-slate-500 dark:text-slate-400">Opens WhatsApp with your message pre-filled — just hit send.</p>
        </div>
      </div>

      <label className="mt-5 block text-xs font-medium text-slate-500 dark:text-slate-400">What&apos;s it about?</label>
      <select
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        className="mt-1.5 w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-violet-500 dark:border-slate-700 dark:bg-[#0b1220] dark:text-slate-200"
      >
        {CATEGORIES.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>

      {isOther ? (
        <input
          type="text"
          value={customText}
          onChange={(e) => setCustomText(e.target.value)}
          placeholder="Tell us briefly what it's about"
          className="mt-3 w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-violet-500 dark:border-slate-700 dark:bg-[#0b1220] dark:text-slate-200"
        />
      ) : null}

      <a
        href={whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full bg-emerald-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-emerald-700"
      >
        Chat on WhatsApp
        <span aria-hidden="true">→</span>
      </a>
    </div>
  );
}
